"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var antd_1 = require("antd");
var dayjs_1 = tslib_1.__importDefault(require("dayjs"));
var locale_1 = tslib_1.__importDefault(require("../../locale"));
var DatePickerWithFilters = function (_a) {
    var _b;
    var value = _a.value, onChange = _a.onChange, defaultValue = _a.defaultValue, props = tslib_1.__rest(_a, ["value", "onChange", "defaultValue"]);
    var now = (0, dayjs_1.default)();
    return (react_1.default.createElement(antd_1.DatePicker.RangePicker, tslib_1.__assign({ value: value, defaultValue: defaultValue, onChange: onChange, ranges: (_b = {},
            _b[locale_1.default.today] = [now.startOf("day"), now.endOf("day")],
            _b[locale_1.default.tomorrow] = [now.add(1, "d").startOf("day"), now.add(1, "d").startOf("day")],
            _b[locale_1.default.thisWeek] = [now.startOf("week"), now.endOf("week")],
            _b[locale_1.default.nextWeek] = [now.add(7, "days").startOf("week"), now.add(7, "days").endOf("week")],
            _b[locale_1.default.thisMonth] = [now.startOf("month"), now.endOf("month")],
            _b[locale_1.default.nextMonth] = [now.add(1, "month").startOf("month"), now.add(1, "month").endOf("month")],
            _b), separator: "→", allowClear: false }, props)));
};
exports.default = DatePickerWithFilters;
//# sourceMappingURL=quick.js.map